module.exports = __webpack_public_path__ + "img/pre_google.0c030307.png";